module.exports = __webpack_public_path__ + "img/cybersecurity-img.96715835.jpg";